import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Checkbox, Text } from 'pcln-design-system'

const ChangeSearchFlexDates = ({ useFlexDates, setUseFlexDates, tripType, isMobile }) => (
  <Flex
    alignItems='center'
    onClick={() => {
      setUseFlexDates(!useFlexDates)
    }}
  >
    <Checkbox
      size={25}
      id={`cshFlexibleDatesOptions${isMobile ? 'Mobile' : 'Desktop'}`}
      checked={useFlexDates}
    />
    <Text fontSize={0}>Flexible Dates (Depart{tripType === 'OW' ? '' : '/Return'} &#177; 1 day)</Text>
  </Flex>
)

ChangeSearchFlexDates.propTypes = {
  tripType: PropTypes.string,
  useFlexDates: PropTypes.bool,
  setUseFlexDates: PropTypes.func,
  isMobile: PropTypes.bool,
}

export { ChangeSearchFlexDates }
